import { render, staticRenderFns } from "./Property-Address.vue?vue&type=template&id=515dfd78"
import script from "./Property-Address.vue?vue&type=script&lang=js"
export * from "./Property-Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports